import { TagModel } from '@hub/models/tag.model';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { SelectItem } from 'primeng/api';

@Component({
    selector: 'tag',
    templateUrl: 'tag.component.html',
    // styleUrls: ['tag.component.css']
})
export class TagComponent implements OnInit {

    @Input() tag: TagModel;
    @Output() em: EventEmitter<TagModel>;

    status: string;

    constructor() {
        this.em = new EventEmitter<TagModel>();
    }

    ngOnInit() {

        switch (this.tag.status) {
            case 0:
                this.status = 'previously-selected';
                break;
            case 1:
                this.status = 'newly-selected';
                break;
            case 2:
                this.status = 'deleted';
                break;
        }
    }

    executeButtonClick() {

        if (this.status === 'deleted') {
            this.em.emit(this.tag);
        }
    }

    executeTagClick() {

        this.em.emit(this.tag);

        switch (this.tag.status) {
            case 0:
                this.status = 'previously-selected';
                break;
            case 1:
                this.status = 'newly-selected';
                break;
            case 2:
                this.status = 'deleted';
                break;
        }
    }

}
